
export enum EVatDisplayMode {
    excludingVAT = 'excludingVAT',
    includingVAT = 'includingVAT'
}
